
import React from 'react';
import { cn } from '@/lib/utils';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './select';

// Wrapper for SelectTrigger that accepts children
interface SelectTriggerWithChildrenProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export const SelectTriggerWithChildren = React.forwardRef<
  HTMLButtonElement,
  SelectTriggerWithChildrenProps
>(({ className, children, ...props }, ref) => (
  <SelectTrigger ref={ref} className={cn(className)} {...props}>
    {children}
  </SelectTrigger>
));

SelectTriggerWithChildren.displayName = 'SelectTriggerWithChildren';

// Wrapper for SelectContent that accepts children
interface SelectContentWithChildrenProps {
  children: React.ReactNode;
  className?: string;
  position?: 'popper' | 'item-aligned';
}

export const SelectContentWithChildren = React.forwardRef<
  HTMLDivElement,
  SelectContentWithChildrenProps
>(({ className, children, ...props }, ref) => (
  <SelectContent ref={ref} className={cn(className)} {...props}>
    {children}
  </SelectContent>
));

SelectContentWithChildren.displayName = 'SelectContentWithChildren';

// Wrapper for SelectItem that accepts children
interface SelectItemWithChildrenProps {
  children: React.ReactNode;
  value: string;
  className?: string;
}

export const SelectItemWithChildren = React.forwardRef<
  HTMLDivElement,
  SelectItemWithChildrenProps
>(({ className, children, value, ...props }, ref) => (
  <SelectItem ref={ref} className={cn(className)} value={value} {...props}>
    {children}
  </SelectItem>
));

SelectItemWithChildren.displayName = 'SelectItemWithChildren';

// Re-export the Select and SelectValue components
export { Select, SelectValue };
